import Container from 'src/components/_layout/Container/Container'
import Text from 'src/components/atoms/Text/Text'
import { StyledPageTitle } from './PageTitle.style'
import type Stitches from '@stitches/react'
import { useSelector } from 'react-redux'
import { getSettings } from 'src/selectors/settings'
type PageTitleProps = {
    title: string
    css?: Stitches.CSS
}

const PageTitle: React.FC<PageTitleProps> = ({ title, css }) => {
    const { underConstruction } = useSelector(getSettings)
    return (
        <StyledPageTitle underConstruction={underConstruction}>
            <Container>
                <Text as="h1" dangerouslySetInnerHTML={{ __html: title }} textVariant="heading1" css={css} />
            </Container>
        </StyledPageTitle>
    )
}

export default PageTitle
